export const COMPANY = {
  name: "HCS Computers AI",
  legalName: "HCS Computers AI — IT Training & Consultancy",
  tagline: "Get trained in in-demand IT technologies, increase your hiring potential.",
  shortTagline: "Train. Certify. Get hired.",
  yearsInBusiness: "20+",
  address: "WeWork Prestige Cube, Koramangala, Bangalore",
  phone: "+91 85490-00328",
  phoneDialable: "+918549000328",
  email: "infohimaniconsult@gmail.com",
  pricePerCourseMonth: 20000,
  certifications: ["PMP", "ITIL", "Salesforce", "AWS"],
};

export const VENDORS = ["Salesforce", "AWS", "Mulesoft", "IBM"];

export const AUX_SERVICES = [
  {
    title: "Resume Build-up",
    description:
      "One-on-one resume rewrites tailored to Salesforce, Cloud, and Integration roles. ATS-friendly, recruiter-approved.",
  },
  {
    title: "Interview Preparation",
    description:
      "Mock interviews with domain experts, scenario-based drills, and negotiation coaching to close the offer.",
  },
  {
    title: "Placement Assistance",
    description:
      "Curated referrals into product companies, consultancies, and system integrators across India and the GCC.",
  },
];
